import { Subject } from "rxjs";

export const errorMessage$ = new Subject();
export const successMessage$ = new Subject();
export const infoMessage$ = new Subject();